import {
  IAdminMonthlyViewTargetsRequest,
  IAdminWeeklyTargetsRequest
} from '../../interfaces/admin-view-targets.interface'

export class AdminGetWeeklyTargets {
  static readonly type = '[AdminViewTargets] Get Weekly Targets'
  constructor(public payload: IAdminWeeklyTargetsRequest) {}
}

export class AdminGetMonthlyViewTargets {
  static readonly type = '[AdminViewTargets] Get Monthly View Targets'
  constructor(public payload: IAdminMonthlyViewTargetsRequest) {}
}
